/*-----------------------------------------------------------------
- Subscription Services
-----------------------------------------------------------------*/
import { Resource } from '../index';

export default {

    /**
     * Subscription  Package fetch
     *
     * @param {...any} args
     * @returns {*}
     */
    packageFetch: (...args) => Resource.get('subscription-package-fetch', args),

    /**
     * Subscription  Packages list
     *
     * @param {...any} args
     * @returns {*}
     */
    packagesList: (...args) => Resource.get('subscription-packages-list', args),

    /**
     * Subscription  Order save
     *
     * @param {...any} args
     * @returns {*}
     */
    orderSave: (...args) => Resource.post('subscription-order-save', args),

    /**
     * Subscription  Order finalize
     *
     * @param {...any} args
     * @returns {*}
     */
    orderFinalize: (...args) => Resource.post('subscription-order-finalize', args),

    /**
     * Subscription  my order coupon inquiry
     *
     * @param {...any} args
     * @returns {*}
     */
    myOrderCouponInquiry: (...args) => Resource.get('subscription-my-order-coupon-inquiry', args),
};
